import type { BeatsData, SectionStatus } from '../../types/canvas';
import { ActionBar } from './ActionBar';

interface BeatsCardProps {
  data: BeatsData;
  status: SectionStatus;
  onApprove?: () => void;
  onRefine?: () => void;
  onAnother?: () => void;
  refineDisabled?: boolean;
}

export function BeatsCard({ data, status, onApprove, onRefine, onAnother, refineDisabled }: BeatsCardProps) {
  return (
    <div className="bg-surface border border-border rounded-lg p-[18px] sm:px-[22px]">
      <h3 className="text-[15px] font-semibold text-foreground mb-3">Emotional Beats</h3>
      <ul className="list-none relative pl-4">
        <span className="absolute left-1 top-2 bottom-2 w-px bg-border" aria-hidden="true" />
        {data.beats.map((beat, i) => (
          <li key={i} className="py-1.5 pl-3 relative text-sm">
            <span
              className={`absolute left-[-12px] top-3 w-[9px] h-[9px] rounded-full border-[1.5px] ${
                beat.isClimax
                  ? 'bg-primary border-primary'
                  : 'bg-background border-muted-foreground'
              }`}
              aria-hidden="true"
            />
            <span className="font-medium text-foreground">{beat.name}</span>
            {' '}
            <span className="font-display italic text-[13px] text-muted-foreground [font-variation-settings:'opsz'_48,'SOFT'_80]">
              {beat.feeling}
            </span>
          </li>
        ))}
      </ul>
      <ActionBar status={status} onApprove={onApprove} onRefine={onRefine} onAnother={onAnother} refineDisabled={refineDisabled} />
    </div>
  );
}
